<template>
    <div class="ls-new-property--container">
        <div class="ls-new-property--add">+</div>
        <span>Add Property</span>
    </div>
</template>

<script>
export default {
    name: 'LsNewProperty',
};
</script>

<style lang="scss" scoped>
.ls-new-property--container {
    display: flex;
    align-items: center;
    width: 100%;
    span {
        color: $secondary;
        font-weight: $semi-bold;
    }
}
.ls-new-property--add {
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: $primary;
    color: $white;
    border-radius: 50%;
    height: 20px;
    width: 20px;
    font-size: $size-2;
    padding-left: 1px;
    margin-right: 8px;
}
</style>
